var React = require('react');

function PlayerFullScreenInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13,1v12H1V1H13z M13.5,0h-13C0.2,0,0,0.2,0,0.5v13C0,13.8,0.2,14,0.5,14h13c0.3,0,0.5-0.2,0.5-0.5v-13\n\t\tC14,0.2,13.8,0,13.5,0L13.5,0z","key":0}),React.createElement("path",{"d":"M5,2H2v3h1V3h2V2z","key":1}),React.createElement("path",{"d":"M11,9v2H9v1h3V9H11z","key":2})]);
}

PlayerFullScreenInline.defaultProps = {"version":"1.1","xmlSpace":"preserve","id":"icon-full-screen","x":"0px","y":"0px","width":"14","height":"14","viewBox":"0 0 14 14"};

module.exports = PlayerFullScreenInline;

PlayerFullScreenInline.default = PlayerFullScreenInline;
